<template>
  <app-base-main no-padding parent-table>
    <template #filter-group>
      <gj-alert
        title="如您的店铺是首次在积加系统中开通VCS lite功能，请先联系积加售后客服打开功能开关后再进行设置"
        type="info"
        :closable="false"
        show-icon
        class="marb10"
      >
      </gj-alert>
      <app-filter-group @query="$gjNoticeQuery" @reset="$gjReset">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
          :width="['140px', '160px']"
        >
        </gj-country-server-select>
        <gj-select
          v-model="filter.status"
          :options="disableOption"
          placeholder="全部状态"
          width="140px"
        >
        </gj-select>
        <gj-select-date-picker
          v-model="filter.date"
          :options="[{ id: 'update', text: '操作时间' }]"
          type="daterange"
        ></gj-select-date-picker>
        <gj-input
          style="width: 250px"
          placeholder="请输入企业名称"
          v-model="filter.companyName"
        >
          <template #append>
            <i class="el-input__icon el-icon-search"></i>
          </template>
        </gj-input>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button @click="pause(selectedRows)">关闭上传</gj-button>
      <gj-button @click="enable(selectedRows)">开启上传</gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group help helpName="vatmanage">
        <template #before>
          <gj-link href="http://help.gerpgo.com/web/#/26/1399" target="_blank">如何开通VCS lite？</gj-link>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
        ref="gjTable"
        :index="false"
        show-overflow
        :loading="loading"
        :data="tableData"
        :columns="columns"
        :pagination="pagination"
        selection
        adapt-parent
        @sort-change="$gjSortChange"
        :default-sort="{ prop: 'id', order: 'descending' }"
        @page-change="$gjNoticeQuery"
      >
        <template v-slot:address="{ row }">
          <span v-if="row.country">{{row.country}}-{{row.province}}-{{row.city}}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:status="{ row }">
          <gj-switch
            size="small"
            :value="row.status === 1"
            @input="switchStatus($event, row)"
          ></gj-switch>
        </template>

        <template v-slot:rejectedNum="{ row }">
          <span v-if="row.rejectedNum" class="colorRed">{{row.rejectedNum}}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:vcsStatus="{ row }">
          <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
            :color="row.vcsStatus | optionColor(vcsStatusOption)">
            {{ row.vcsStatus | optionText(vcsStatusOption) }}
          </gj-tag>
        </template>

        <template v-slot:op="{ row }">
          <gj-button-group
            type="dropdown-op"
            :showLength="2"
            :config="opBtnConfig(row)"
          ></gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { tagColors } from "@/components/tag/tag-colors";
import AppVatEditModal from "./modal/vat-edit-modal";
import { disableOption } from "@/utils/options";
import { isMeaningful, isMeaningless } from "@/utils/common";
import { optionText } from "@/filters";
import { isMeaningfulMixin, queryMixin, selectionMixin } from "@/minxins";
import { convertToDate } from "@/utils/date.util";
import { mapGetters } from "vuex";
import { vatInvoiceList, vatInvoiceModifyStatus } from "@/api/vat"
export default {
  name: "vat-manage",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
  computed: {
    ...mapGetters({
      marketOption: "marketOption",
    }),
  },
  data() {
    return {
      filter: {
        countryMarketValue: {},
        status: null,
        date: {
          key: "update",
          value: "",
        },
        companyName: null,
      },
      disableOption,
      uploadTypeOption: [
        { id:'all', text: '所有订单' },
        { id:'b2b', text: '企业订单（B2B）' }
      ],
      vcsStatusOption: [
        { id: 0, text: '未开通', ...tagColors.gray6Text },
        { id: 1, text: '待确认', ...tagColors.redText },
        { id: 2, text: '已开通', ...tagColors.gray6Text }
      ],
      columns: [
        {
          id: "marketId",
          header: "店铺/国家",
          field: "option:marketId",
          minWidth: "120px",
          default: true,
          options: () => this.marketOption,
        },
        {
          id: "companyName",
          header: "企业名称",
          field: "companyName",
          minWidth: "200px",
          default: true,
        },
        {
          id: "uploadType",
          header: "上传订单类型",
          field: "option:uploadType",
          minWidth: "120px",
          default: true,
          options: () => this.uploadTypeOption,
        },
        {
          id: "address",
          header: "企业地址",
          field: "slot:address",
          minWidth: "240px",
          align: "left",
        },
        {
          id: "pendingNum",
          header: "待上传",
          field: "pendingNum",
          minWidth: "100px",
          align: "left",
        },
        {
          id: "processingNum",
          header: "上传中",
          field: "processingNum",
          minWidth: "100px",
          align: "left",
        },
        {
          id: "uploadedNum",
          header: "上传成功",
          field: "uploadedNum",
          minWidth: "100px",
          align: "left",
        },
        {
          id: "rejectedNum",
          header: "上传失败",
          field: "slot:rejectedNum",
          minWidth: "100px",
          align: "left",
        },
        {
          id: "status",
          header: "状态",
          field: "slot:status",
          minWidth: "100px",
        },
        {
          id: "userName",
          header: "操作人",
          field: "userName",
          minWidth: "100px",
          align: "left",
        },
        {
          id: "updateTime",
          header: "操作时间",
          field: "updateTime",
          sortable: true,
          minWidth: "130px",
        },
        {
          id: "vcsStatus",
          header: "VCS状态",
          field: "slot:vcsStatus",
          minWidth: "120px",
          align: "center",
          sortable: true,
          help: "待确认状态：系统在等待亚马逊后台返回激活结果中"
        },
        {
          id: "op",
          header: "操作",
          field: "slot:op",
          width: "150px",
          fixed: "right",
          notCustomColumn: true,
          disabled: true,
        },
      ],
      opBtnConfig: (row) => [
        {
          label: "编辑企业信息",
          show: () => true,
          click: () => this.openEdit(row),
        },
        {
          label: "日志",
          show: () => true,
          click: () => this.openLog(row),
        },
      ],
      tableData: []
    };
  },
  methods: {
    // 搜索
    async $gjQuery() {
      let { status, companyName } = this.filter
      const params = {
        model: {
          status,
          companyName
        },
        ...this.queryPagination,
        ...this.querySort
      };
      if(!params.sort) {
        params.sort = 'id'
        params.order = 'descending'
      }
      if (this.filter.countryMarketValue) {
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
      }
      if (this.isMeaningful(this.filter.date.value)) {
        params.model.beginDate = convertToDate(this.filter.date.value[0]);
        params.model.endDate = convertToDate(this.filter.date.value[1]);
      }
      this.loading = true;
      try {
        const {data} = await vatInvoiceList(params);
        this.tableData = data.records;
        this.pagination = this.getPagination(data);
      } finally {
        this.loading = false;
      }
    },

    $gjQueryInitParams() {
      return {
        filter: {
          countryMarketValue: {},
          status: null,
          companyName: "",
          date: {
            key: "update",
            value: "",
          },
        },
      };
    },

    switchStatus(open, row) {
      if (open) {
        this.enable([row]);
      } else {
        this.pause([row]);
      }
    },

    enable(rows) {
      // 未勾选列表数据，直接点击“开启上传”，则提示用户：请选择需要启用自动上传发票功能的店铺/国家
      if (rows.length === 0) {
        this.$gjMessage.error('请选择需要启用自动上传发票功能的店铺/国家')
        return
      }
      // 获取勾选列表数据中的未开启自动上传功能的店铺
      let pauseShop = rows.filter((item) => item.status == 0)
      // 勾选的列表数据中，只存在启用状态的数据，点击“开启上传”，则提示用户：当前选中的店铺/国家已启用自动上传发票功能
      if (pauseShop.length === 0) {
        let enableShop = rows.map((item) => optionText(item.marketId, this.marketOption));
        this.$gjMessage.error(`当前选中的【${enableShop.join('、')}】已启用自动上传发票功能`)
      } else {
        // 获取未开启自动上传功能的店铺中信息未完善的店铺
        let failShop = pauseShop.filter(item => isMeaningless(item.companyName) || isMeaningless(item.country) || isMeaningless(item.province) || isMeaningless(item.city))
                                .map((item) => optionText(item.marketId, this.marketOption));
        // 企业信息存在未填写，则提示用户：【店铺/站点】未填写企业信息，请您填写企业信息后再启用自动上传发票功能
        if (failShop.length > 0) {
          const modal = this.$gjCreate("gj-info-modal", {
            props: {
              title: "开启上传",
              content: `【${failShop.join('、')}】未填写企业信息，请您填写企业信息后再启用自动上传发票功能`,
            },
            on: {
              confirm: () => modal.$gjDestroy(),
            },
          });
        } else {
          const modal = this.$gjCreate("gj-info-modal", {
            props: {
              title: "开启上传",
              type: 'warning',
              content: "启用自动上传发票功能后，系统仅能获取您开通VCS Lite后的需要上传发票的订单信息，为避免影响您的店铺绩效，您需要手动处理开通VCS Lite前的待上传的发票；确认启用自动上传发票功能吗？",
            },
            on: {
              cancel: () => modal.$gjDestroy(),
              confirm: () => {
                modal.confirmLoading = true;
                let marketList = pauseShop.filter(item => isMeaningful(item.companyName) && isMeaningful(item.country) && isMeaningful(item.province) && isMeaningful(item.city))
                                       .map((item) => item.marketId)
                let params = {
                  marketList,
                  status: 1
                }
                vatInvoiceModifyStatus(params)
                  .then(() => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  })
                  .complete(() => modal.confirmLoading = false);
              },
            },
          });
        }
      }
    },

    pause(rows) {
      // 未勾选列表数据，直接点击“关闭上传”，则提示用户：请选择需要关闭自动上传发票功能的店铺/国家
      if (rows.length === 0) {
        this.$gjMessage.error('请选择需要关闭自动上传发票功能的店铺/国家')
        return
      }
      // 获取勾选列表数据中的已开启自动上传功能的店铺
      let enableShop = rows.filter((item) => item.status == 1)
                         .map((item) => optionText(item.marketId, this.marketOption));
      // 勾选的列表数据中，只存在停用状态的数据，点击“关闭上传”，则提示用户：当前选中的店铺/国家未开启自动上传发票功能
      if(enableShop.length === 0) {
        let pauseShop = rows.map((item) => optionText(item.marketId, this.marketOption));
        this.$gjMessage.error(`当前选中的【${pauseShop.join('、')}】未开启自动上传发票功能`)
      } else {
        // 勾选的列表数据中，存在启用状态的数据，点击“关闭上传”，则提示用户：启用状态的店铺/国家，在关闭自动上传发票功能后，系统将立即停止上传发票；为避免影响您的店铺绩效，
        // 在关闭此功能时，请先确认【店铺/国家、店铺/国家、】是否还存在待上传的发票；确认停用自动上传发票功能吗？
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: "关闭上传",
            type: 'warning',
            content: `启用状态的【${enableShop.join('、')}】，在关闭自动上传发票功能后，系统将立即停止上传发票；为避免影响您的店铺绩效，在关闭此功能时，请先确认【${enableShop.join('、')}】是否还存在待上传的发票；
            确认停用自动上传发票功能吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              const marketList = rows.filter((item) => item.status == 1)
                                     .map((item) => item.marketId);
              let params = {
                marketList,
                status: 0
              }
              vatInvoiceModifyStatus(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            },
          },
        });
      }
    },

    //  查看日志
    openLog(row) {
      this.$gjCreate("gj-log-modal", {
        props: {
          url: "/base/vatInvoice/logs",
          params: {
            model: {
              fid: row.id
            }
          },
          opTypeOption: [
            {id: 'EditStatus', text: '编辑状态'},
            {id: 'EditEnterprise', text: '编辑企业信息'}
          ]
        },
      });
    },

    // 编辑企业信息
    openEdit(row) {
      this.$gjCreate(AppVatEditModal, {
        props: {
          item: row,
        },
        on: {
          updated: async (status) => {
            this.$gjQuery();
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.marb10 {
  margin-bottom: 10px;
}
.base-main {
  /deep/.el-input-group__append {
    border: 0;
    background: #fff;
    position: absolute;
    top: 2px;
    right: 2px;
    padding: 0;
    width: 0;
    height: 80%;
  }
  /deep/ .operate-group {
    margin: 10px 0 10px;
  }
}
</style>